var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3633 2.97656C11.75 2.73047 12.0312 2.30859 12.0312 1.78125C12.0312 1.00781 11.3984 0.375 10.625 0.375C9.81641 0.375 9.21875 1.00781 9.21875 1.78125C9.21875 2.30859 9.46484 2.73047 9.88672 2.97656L7.84766 7.01953C7.53125 7.65234 6.72266 7.82812 6.16016 7.40625L3.03125 4.875C3.20703 4.66406 3.3125 4.34766 3.3125 4.03125C3.3125 3.25781 2.67969 2.625 1.90625 2.625C1.09766 2.625 0.5 3.25781 0.5 4.03125C0.5 4.83984 1.09766 5.4375 1.90625 5.4375L3.52344 14.2969C3.69922 15.3516 4.64844 16.125 5.73828 16.125H15.4766C16.5664 16.125 17.5156 15.3516 17.6914 14.2969L19.3086 5.4375C19.3086 5.4375 19.3086 5.4375 19.3438 5.4375C20.1172 5.4375 20.75 4.83984 20.75 4.03125C20.75 3.25781 20.1172 2.625 19.3438 2.625C18.5352 2.625 17.9375 3.25781 17.9375 4.03125C17.9375 4.34766 18.043 4.66406 18.2188 4.875L15.0547 7.40625C14.5273 7.82812 13.6836 7.65234 13.3672 7.01953L11.3633 2.97656Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default ForwardRef;